function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName('tabcontent');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.visibility = 'hidden';
    tabcontent[i].style.height = '0';
    tabcontent[i].style.padding = '0';
  }
  tablinks = document.getElementsByClassName('tablinks');
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '');
  }
  document.getElementById(cityName).style.visibility = 'visible';
  document.getElementById(cityName).style.height = '100%';
  document.getElementById(cityName).style.padding = '2em 2em .5em 2em';
  evt.currentTarget.className += ' active';
}